import { z } from 'zod';
import { attachmentSchema } from '../../attachments/index.js';
import { SecurityLevel } from '../../shared/index.js';
export const legislativeItemAttachmentCreateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    legislativeAttachmentTypeId: z
        .union([z.number(), z.string().transform((val) => Number(val))])
        .nullable(),
    securityLevel: z.enum(SecurityLevel),
    allowedUserIds: z.preprocess((val) => (Array.isArray(val) ? val : []), z.array(z.number().int().positive())),
    attachment: attachmentSchema,
});
export const legislativeItemAttachmentUpdateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    legislativeAttachmentTypeId: z
        .union([z.number(), z.string().transform((val) => Number(val))])
        .nullable(),
    securityLevel: z.enum(SecurityLevel),
    allowedUserIds: z.preprocess((val) => (Array.isArray(val) ? val : []), z.array(z.number().int().positive())),
});
export const legislativeItemAttachmentReorderSchema = z.object({
    legislativeItemAttachments: z.array(z.object({
        id: z.number(),
    })),
});
/**
 * Free-form override of a single attachment's number. A null/blank value clears it. Re-running
 * Auto Number re-sequences all attachments, overwriting manual overrides.
 */
export const legislativeItemAttachmentNumberUpdateSchema = z.object({
    attachmentNumber: z.string().max(50).nullable(),
});
